import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import global from "@/utils/global";
import regexp from "@/utils/regexp";
import filters from "@/filters/index";
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.bubble.css';
import 'quill/dist/quill.snow.css';
import VueQuillEditor from "vue-quill-editor";
import "amfe-flexible";
import md5 from "js-md5";
import CryptoJS from 'crypto-js';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { getUploadHeaders, openWindowWithToken } from "@/utils/auth";


//全局样式
import "./assets/css/reset.css";
import { ImagePreview } from 'vant';
Vue.use(require("vue-wechat-title"));
Vue.use(ImagePreview);
//引入过滤器
Vue.use(filters);

Vue.use(VueQuillEditor);
Vue.use(ElementUI);
Vue.prototype.$md5 = md5;
Vue.prototype.$CryptoJS = CryptoJS;
Vue.config.productionTip = false;
Vue.prototype.$global = global;
Vue.prototype.$regexp = regexp;
Vue.prototype.getUploadHeaders = getUploadHeaders;
Vue.prototype.openWindowWithToken = openWindowWithToken;
// import VConsole from "vconsole";

// new VConsole

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

import { getSessionStore } from "@/utils/sessionStorage"
// 使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {
  let token = getSessionStore("access_token")
  if(token){
    next();
  }else{
    if (to.path !== "/login"//登录
    && to.path !=="/register"//注册
    && to.path !=="/meetRegister"//注册
    && to.path !=="/person"//个人注册
    && to.path !=="/group" //单位注册
    && to.path !=="/signinPage" //签到
    && to.path !=="/MeetingList"//会议列表
    && to.path !=="/MeetingDetails"//会议详情
    && to.path !=="/signup"//会议报名
    && to.path !=="/signupSearch"//报名查询
    && to.path !=="/getPassword" 
    && to.path !== "/rule"
    && to.path !=="/memberSearch"//会员查询
    ) {
      next("/login");
    }else{
      next()
    }
  }
});
